import { Alert, Box, useTheme } from "@mui/material";
import React from "react";

import { useAuth } from "@/providers";
import { PageLayout } from "@/shared/components";

import { DevicesTable } from "./DevicesTable";

export const Devices: React.FC = () => {
  const { currentOrganization } = useAuth();
  const theme = useTheme();

  return (
    <PageLayout title={"Roboto - Devices"} headerContentLeft={"Devices"}>
      <Box marginBottom={theme.spacing(3)}>
        <Alert severity="info">
          Devices are robots, systems, or other non-human entities that can
          interact with Roboto on behalf of your organization.
        </Alert>
      </Box>
      <DevicesTable orgId={currentOrganization?.org_id} />
    </PageLayout>
  );
};
